<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="10" fill="#FFFFFF" class="bg" />
    <circle cx="12" cy="12" r="10" fill="none" stroke="#2A2B2A" stroke-width="1.5" class="stroke" />
    <path
      d="M11 18h2v-2h-2v2zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z"
      fill="#2A2B2A"
      class="fill"
      transform="translate(3.2 3.2) scale(0.8)"
    />
  </svg>
</template>

<style lang="scss" scoped>
svg .bg {
  fill: #ffffff;
}

svg .stroke {
  stroke: #2a2b2a;
}

svg .fill {
  fill: #2a2b2a;
}

.icon-primary svg .stroke {
  stroke: #3273f6;
}

.icon-primary svg .fill {
  fill: #3273f6;
}
</style>
